import { render } from "./ClavierView.vue?vue&type=template&id=11d944cd&scoped=true"
import script from "./ClavierView.vue?vue&type=script&lang=js"
export * from "./ClavierView.vue?vue&type=script&lang=js"

import "./ClavierView.vue?vue&type=style&index=0&id=11d944cd&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d944cd"]])

export default __exports__